export const ALIGN_FORM_TYPES = {
  CENTER: "center",
  RIGHT: "right",
  LEFT: "left",
};